import React from "react";
import { TopTextReusableComponent } from "../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

export const MultipleStandardHours = ({
  mutipleStandardHoursYesButtonClicked,
  multipleStandardHoursNoButtonClicked,
  multipleStandardHoursBackButtonClicked,
}) => {
  return (
    <React.Fragment>
      <div>
        <TopTextReusableComponent
          headingText="Business Timings"
          headingParagraph="Enter the details about the timing of your Business"
        />
      </div>
      <div className="are-you-open-main">
        <div className="are-you-open-main-sectionone">
          {/* <h5>Do you have Multiple Opening Hours?</h5> */}
          <h5>Set Up Your Business Hours Timings</h5>
          <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 are-you-open-main-sectionone-inside margin-bottom-chains-onboarding">
            <ReusableOnboardingButton
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Yes"
              buttonType="button"
              onClick={mutipleStandardHoursYesButtonClicked}
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              buttonText="No"
              buttonType="button"
              onClick={multipleStandardHoursNoButtonClicked}
            />
          </div>
        </div>
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button mt-5">
        <ReusableOnboardingButton
          buttonTitle="Back Button"
          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
          buttonText="Back"
          onClick={multipleStandardHoursBackButtonClicked}
        />
      </div>
    </React.Fragment>
  );
};
